<template>
    <a v-if="url !== null"
       :href="url"
       :class="`category-pill--${color}`"
       class="category-pill"
       v-html="name"
    ></a>

    <a v-else
       :class="`category-pill--${color}`"
       class="category-pill category-pill--no-hover"
       v-html="name"
    ></a>
</template>

<script>
    export default {
        name: 'CategoryPill',

        props: {
            name:  { type: String, required: true },
            color: { type: String, required: true },
            url:   { type: String, default: null },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_placeholders';

    .category-pill {
        @extend %font-OpenSans-regular;

        display:       inline-block;
        border-radius: 2rem;
        padding:       0.1rem 1.5rem;

        border:        0.1rem solid currentColor;
        color:         $white; // To override a Bootstrap rule
        font-size:     1.2rem;

        transition:    all 150ms ease-in-out;

        &--no-hover {
            color: $white !important;
        }

        :not(&--no-hover):hover,
        &:focus {
            background-color: transparent;
            text-decoration:  none;
        }

        &--red {
            background: $color-red;

            &:hover,
            &:focus {
                color: $color-red;
            }
        }
        &--green {
            background: $color-green;

            &:hover,
            &:focus {
                color: $color-green;
            }
        }
        &--blue {
            background: $color-blue;

            &:hover,
            &:focus {
                color: $color-blue;
            }
        }
        &--gray {
            background: $gray-700;

            &:hover,
            &:focus {
                color: $gray-700;
            }
        }
    }
</style>
